import { AlkLogger } from '@alk/core';
import { finalize, takeUntil } from 'rxjs/operators';
import { inject, injectable } from 'inversify';
import {
    IPriceService,
    ISpotQuote,
    SpotPriceRequest,
} from '../../../interfaces';
import { ISelectedClientService, SELECTED_CLIENT_SERVICE } from '../../selected-client';
import { ISessionLifecycle, SESSION_LIFECYCLE_SERVICE } from '../../session-lifecycle';
import { ISubscriptionPoolingService, SUBSCRIPTION_POOLING_SERVICE } from '../subscription-pooling';
import { NEVER, Observable } from 'rxjs';
import { validatePadRequest } from './esp-price.utils';

@injectable()
export class EspPriceService implements IPriceService {

    @inject(SUBSCRIPTION_POOLING_SERVICE) private readonly subscriptionPoolingService: ISubscriptionPoolingService;
    @inject(SELECTED_CLIENT_SERVICE) private readonly selectedClientSrv: ISelectedClientService;
    @inject(SESSION_LIFECYCLE_SERVICE) private readonly sessionLifeCycle: ISessionLifecycle;

    quoteObservable(request: SpotPriceRequest): Observable<ISpotQuote> {

        AlkLogger.debug(`[ESP_PRICE_SERVICE#quoteObservable] requested price with: ${ JSON.stringify(request) }`);

        const validationResult = validatePadRequest(request);

        if (Boolean(validationResult)){
            AlkLogger.error(validationResult);
            return NEVER;
        }

        const requestWithClient = { ...request, clientId: this.selectedClientSrv.getCurrent()?.id };
        const clientToken = this.subscriptionPoolingService.create(requestWithClient);

        return this.subscriptionPoolingService.spotPriceObservable(clientToken).pipe(
            takeUntil(this.sessionLifeCycle.destroyObservable()),
            finalize(this.subscriptionPoolingService.unsubscribe.bind(null, clientToken)),
        );
    }
}
